/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdministrativeResponseListResponse } from '../models/administrative-response-list-response';
import { getFeV1Administratives$Json } from '../fn/administrative/get-fe-v-1-administratives-json';
import { GetFeV1Administratives$Json$Params } from '../fn/administrative/get-fe-v-1-administratives-json';
import { getFeV1Administratives$Plain } from '../fn/administrative/get-fe-v-1-administratives-plain';
import { GetFeV1Administratives$Plain$Params } from '../fn/administrative/get-fe-v-1-administratives-plain';

@Injectable({ providedIn: 'root' })
export class AdministrativeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFeV1Administratives()` */
  static readonly GetFeV1AdministrativesPath = '/v1/administratives';

  /**
   * Gets all administratives.
   *
   * Gets all administratives.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Administratives$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Administratives$Plain$Response(params?: GetFeV1Administratives$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrativeResponseListResponse>> {
    return getFeV1Administratives$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all administratives.
   *
   * Gets all administratives.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Administratives$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Administratives$Plain(params?: GetFeV1Administratives$Plain$Params, context?: HttpContext): Observable<AdministrativeResponseListResponse> {
    return this.getFeV1Administratives$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrativeResponseListResponse>): AdministrativeResponseListResponse => r.body)
    );
  }

  /**
   * Gets all administratives.
   *
   * Gets all administratives.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Administratives$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Administratives$Json$Response(params?: GetFeV1Administratives$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrativeResponseListResponse>> {
    return getFeV1Administratives$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all administratives.
   *
   * Gets all administratives.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Administratives$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Administratives$Json(params?: GetFeV1Administratives$Json$Params, context?: HttpContext): Observable<AdministrativeResponseListResponse> {
    return this.getFeV1Administratives$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrativeResponseListResponse>): AdministrativeResponseListResponse => r.body)
    );
  }

}
